import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AddModalButton, CloseButton, modalsStyle, ValidationInput } from 'components';
import {
  ErrorText,
  FindLoad,
  FindSuccess,
  globalModals,
  useGlobalTextStyles,
  useModal,
  useSecondaryModal,
} from 'utils';
import { httpRequestsOnSuccessActions, noteActions } from 'store';

export const NotesMultipleAdd = ({ info, currentId, commentType }) => {
  const [text, setText] = useState();
  const [errorText, setErrorText] = useState(false);
  const { close } = useModal();
  const dispatch = useDispatch();
  const ACTION_TYPE = info ? 'EDIT_GLOBAL_NOTE' : 'CREATE_GLOBAL_NOTE';
  const loading = FindLoad(ACTION_TYPE);
  const success = FindSuccess(ACTION_TYPE);
  const globalModalsClasses = globalModals();
  const globalText = useGlobalTextStyles();
  const classes = modalsStyle();

  useEffect(() => {
    if (info?.text) {
      setText(info?.text);
    }
  }, [info]);

  useEffect(() => {
    if (success?.length) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
      close();
    }
  }, [success]);

  const handleChange = (e) => {
    setText(e?.target.value);
    setErrorText(false);
  };

  const handleSnd = () => {
    if (text) {
      const noteData = {
        subject: ' ',
        text: text,
      };

      if (info?.id) {
        dispatch(noteActions.editGlobalNote(currentId, info?.id, noteData, commentType));
      } else {
        noteData.resource = currentId;
        noteData.type = commentType
        dispatch(noteActions.createGlobalNote(noteData));
      }
    } else {
      setErrorText(true);
    }
  };

  return (
    <div className={globalModalsClasses.smallModalWrapper}>
      <div className={globalModalsClasses.smallModalClose}>
        <CloseButton handleCLic={close} />
      </div>

      <div className={globalModalsClasses.modalWrapperContent}>
        <p className={globalText.modalTitleWithMargin}>{info ? 'Edit' : 'Add'} Correction Note</p>

        <ValidationInput
          className={text ? classes.inputTextFieldBlue : classes.inputTextField}
          variant={'outlined'}
          name={'instruction'}
          label={'Add Notes'}
          type={'text'}
          multiline={true}
          Length={200}
          typeError={errorText && ErrorText.field}
          onChange={handleChange}
          value={text}
        />
        <div className={classes.maxCharacters}>
          <p>{`Max ${text ? text?.length : 0}/200 characters`}</p>
        </div>
        <AddModalButton
          loading={!!loading.length}
          styles={{ marginTop: '16px' }}
          handleClick={handleSnd}
          text={info ? 'Edit' : 'Add'}
        />
      </div>
    </div>
  );
};

